"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFeature = void 0;
const defaultHooks = {
    metaInit() {
        /**/
    },
    analyzeInit() {
        /**/
    },
    analyzeAtRule() {
        /**/
    },
    analyzeSelectorNode() {
        /**/
    },
    analyzeDeclaration() {
        /**/
    },
    prepareAST() {
        /**/
    },
    transformInit() {
        /**/
    },
    transformResolve() {
        return {};
    },
    transformAtRuleNode() {
        /**/
    },
    transformSelectorNode() {
        /**/
    },
    transformDeclaration() {
        /**/
    },
    transformValue() {
        /**/
    },
    transformJSExports() {
        /**/
    },
    transformLastPass() {
        /**/
    },
};
function createFeature(hooks) {
    return {
        ...defaultHooks,
        ...hooks,
    };
}
exports.createFeature = createFeature;
//# sourceMappingURL=feature.js.map